import { TMatchOfficeOption } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Select } from "@/components/elements/Select";
import { TUserSettingForm } from "@/features/user-setting/types/UserSettingForm";
import { black, divider } from "@/theme/colors";
import { TOption } from "@/types/common";
import { truncateWithEllipsis } from "@/utils/string";
import { Grid, Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useFormContext } from "react-hook-form";

type TAccountInfoFormProps = {
  matchOfficeOptions?: TMatchOfficeOption[];
};

export const AccountInfoForm: FC<TAccountInfoFormProps> = ({ matchOfficeOptions = [] }) => {
  const methods = useFormContext<TUserSettingForm>();
  const { control } = methods;

  const matchOfficeSelectOptions: TOption[] = useMemo(
    () =>
      [...matchOfficeOptions]
        .sort((a, b) => (a.id ?? 0) - (b.id ?? 0))
        .map((option) => ({ label: truncateWithEllipsis(option.officeName ?? "", 25), value: option.id })),
    [matchOfficeOptions],
  );

  return (
    <InnerBox padding={3} showDivider={false} borderColor={divider.high}>
      <Stack alignItems="flex-start">
        <Typography variant="sub16Bold" color={black[30]}>
          アカウント情報
        </Typography>
      </Stack>

      <Grid container columnSpacing="20px">
        <Grid item xs={4}>
          <FormField control={control} name="userDepartment">
            <Input sx={{ mt: 0.5 }} />
          </FormField>
        </Grid>
        <Grid item xs={4}>
          <FormField control={control} name="userPosition">
            <Input sx={{ mt: 0.5 }} />
          </FormField>
        </Grid>
        <Grid item xs={4}>
          <FormField control={control} name="matchOfficeId" label="紹介事業所">
            <Select options={matchOfficeSelectOptions} placeholder="選択してください" sx={{ mt: 0.5 }} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
